(function () {
    "use strict";
    var dom = null,
        cache = {},
        inflight = {},
        state = null;

    function ic(n) {
        return '<i class="ph-bold ' + n + '"></i>'
    }

    function paintIcons() {
        window.UntamedIcons && dom && window.UntamedIcons.refresh(dom.sheet)
    }

    function esc(s) {
        return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
            return {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;"
            }[c]
        })
    }

    function money(cents) {
        if (window.formatMoney && window.themeMoneyFormat) try {
            return window.formatMoney(cents, window.themeMoneyFormat)
        } catch (e) { }
        return "$" + (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
    }

    function isColor(name) {
        return /colou?r/i.test(name || "")
    }

    function swatchColor(name) {
        var ucs = window.UntamedColorSwatches;
        if (ucs && typeof ucs.resolve == "function") {
            var hex = ucs.resolve(name);
            if (hex) return hex
        }
        var n = String(name).trim().toLowerCase().replace(/\s+/g, "");
        return /^[a-z]+$/.test(n) ? n : ""
    }

    function build() {
        if (dom) return dom;
        var scrim = document.createElement("div");
        scrim.className = "ui-sheet-overlay", scrim.setAttribute("data-ui-sheet-overlay", "quick-view"), scrim.setAttribute("aria-hidden", "true");
        var sheet = document.createElement("div");
        return sheet.className = "ui-sheet ui-sheet--quickview", sheet.setAttribute("data-ui-sheet", "quick-view"), sheet.setAttribute("role", "dialog"), sheet.setAttribute("aria-modal", "true"), sheet.setAttribute("aria-hidden", "true"), sheet.innerHTML = '<div class="ui-sheet__header"><h3 class="ui-sheet__title" data-ui-sheet-title>Quick view</h3><button type="button" class="ui-sheet__close" data-ui-sheet-close aria-label="Close">' + ic("ph-x") + '</button></div><div class="ui-sheet__body" data-qv-root></div>', document.body.appendChild(scrim), document.body.appendChild(sheet), dom = {
            scrim: scrim,
            sheet: sheet,
            body: sheet.querySelector("[data-qv-root]")
        }, document.addEventListener("ui-sheet:close", function (e) {
            e.detail && e.detail.id === "quick-view" && state && (emit("quick_view_closed", {
                product_handle: state.product.handle
            }), state = null)
        }), dom
    }

    function open(handle, source) {
        build(), emit("quick_view_opened", {
            product_handle: handle,
            source: source || "card_tap"
        }), cache[handle] ? render(cache[handle]) : (dom.body.innerHTML = skeleton(), fetchProduct(handle).then(render).catch(function () {
            dom.body.innerHTML = '<div class="qv-loading">Couldn\'t load this item.<br><a class="ui-sheet__btn ui-sheet__btn--secondary qv-view-full" href="/products/' + esc(handle) + '">View full details</a></div>'
        })), window.UISheet ? window.UISheet.open("quick-view") : (dom.scrim.setAttribute("aria-hidden", "false"), dom.sheet.setAttribute("aria-hidden", "false"))
    }

    function close() {
        window.UISheet ? window.UISheet.close() : dom && (dom.scrim.setAttribute("aria-hidden", "true"), dom.sheet.setAttribute("aria-hidden", "true"))
    }

    function fetchProduct(handle) {
        return cache[handle] ? Promise.resolve(cache[handle]) : (inflight[handle] || (inflight[handle] = fetch("/products/" + handle + ".js", {
            headers: {
                Accept: "application/json"
            }
        }).then(function (r) {
            if (!r.ok) throw new Error("fetch");
            return r.json()
        }).then(function (p) {
            return cache[handle] = p, delete inflight[handle], p
        }).catch(function (e) {
            throw delete inflight[handle], e
        })), inflight[handle])
    }

    function prefetch(handle) {
        !handle || cache[handle] || inflight[handle] || fetchProduct(handle).catch(function () { })
    }

    function skeleton() {
        return '<div class="qv-skeleton" data-qv-skeleton><div class="qv-skeleton__media sk-shimmer"></div><div class="qv-skeleton__content"><span class="sk-line sk-shimmer" style="width:32%;height:11px"></span><span class="sk-line sk-shimmer" style="width:78%;height:24px;margin-top:10px"></span><span class="sk-line sk-shimmer" style="width:40%;height:22px;margin-top:16px"></span><div class="qv-skeleton__row"><span class="sk-chip sk-shimmer"></span><span class="sk-chip sk-shimmer"></span><span class="sk-chip sk-shimmer"></span></div><div class="qv-skeleton__row"><span class="sk-dot sk-shimmer"></span><span class="sk-dot sk-shimmer"></span><span class="sk-dot sk-shimmer"></span></div><span class="sk-line sk-shimmer" style="width:100%;height:52px;margin-top:auto;border-radius:100px"></span></div></div>'
    }

    function emit(name, detail) {
        try {
            window.dataLayer = window.dataLayer || [], window.dataLayer.push(Object.assign({
                event: name
            }, detail || {})), window.Shopify && window.Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(name, detail || {})
        } catch (e) { }
    }

    function render(p) {
        var firstAvail = p.variants.filter(function (v) {
            return v.available
        })[0] || p.variants[0],
            chosen = (firstAvail.options || []).slice();
        state = {
            product: p,
            chosen: chosen,
            mediaIndex: 0,
            qty: 1
        };
        var media = p.media && p.media.length ? p.media : (p.images || []).map(function (src) {
            return {
                src: src,
                media_type: "image"
            }
        });
        dom.body.innerHTML = '<div class="qv-media" data-qv-media></div><div class="qv-content" data-qv-body></div>', renderMedia(media), renderBody(), paintIcons(), revealContent()
    }

    function revealContent() {
        var mediaEl = dom.body.querySelector("[data-qv-media]"),
            contentEls = dom.body.querySelectorAll(".qv-content > *");

        function run(gsap) {
            gsap && (gsap.fromTo(mediaEl, {
                autoAlpha: 0,
                scale: 1.02
            }, {
                autoAlpha: 1,
                scale: 1,
                duration: .5,
                ease: "power2.out"
            }), gsap.fromTo(contentEls, {
                autoAlpha: 0,
                y: 12
            }, {
                autoAlpha: 1,
                y: 0,
                duration: .45,
                ease: "power2.out",
                stagger: .05,
                delay: .05
            }))
        }
        window.gsap ? run(window.gsap) : window.gsapReady && window.gsapReady.then && window.gsapReady.then(run).catch(function () { })
    }

    function currentVariant() {
        for (var p = state.product, i = 0; i < p.variants.length; i++) {
            for (var v = p.variants[i], ok = !0, k = 0; k < state.chosen.length; k++)
                if (String(v.options[k]) !== String(state.chosen[k])) {
                    ok = !1;
                    break
                } if (ok) return v
        }
        return null
    }

    function valueAvailable(idx, val) {
        for (var p = state.product, i = 0; i < p.variants.length; i++) {
            var v = p.variants[i];
            if (v.available && String(v.options[idx]) === String(val)) {
                for (var ok = !0, k = 0; k < p.options.length; k++)
                    if (k !== idx && String(v.options[k]) !== String(state.chosen[k])) {
                        ok = !1;
                        break
                    } if (ok) return !0
            }
        }
        return !1
    }

    function renderMedia(media) {
        var wrap = dom.body.querySelector("[data-qv-media]");
        if (!media.length) {
            wrap.innerHTML = "";
            return
        }
        var i = state.mediaIndex,
            m = media[i],
            mainSrc = m.src || m.preview_image && m.preview_image.src || m,
            isVid = m.media_type === "video";
        wrap.innerHTML = '<div class="qv-media-main"><span class="qv-media-counter">' + (i + 1) + " / " + media.length + "</span>" + (isVid ? '<video src="' + esc(m.sources && m.sources[0] && m.sources[0].url || mainSrc) + '" muted playsinline loop autoplay></video>' : '<img src="' + esc(mainSrc) + '" alt="">') + (media.length > 1 ? '<button class="qv-media-arrow prev" data-qv-prev ' + (i === 0 ? "disabled" : "") + ">" + ic("ph-caret-left") + '</button><button class="qv-media-arrow next" data-qv-next ' + (i === media.length - 1 ? "disabled" : "") + ">" + ic("ph-caret-right") + "</button>" : "") + "</div>" + (media.length > 1 && (!window.UntamedSheets || !window.UntamedSheets.qv || window.UntamedSheets.qv.showThumbnails !== !1) ? '<div class="qv-thumbs">' + media.map(function (mm, idx) {
            var t = mm.preview_image && mm.preview_image.src || mm.src || mm;
            return '<button class="qv-thumb' + (idx === i ? " is-active" : "") + '" data-qv-thumb="' + idx + '"><img src="' + esc(t) + '" alt=""></button>'
        }).join("") + "</div>" : "");
        var prev = wrap.querySelector("[data-qv-prev]"),
            next = wrap.querySelector("[data-qv-next]");
        prev && prev.addEventListener("click", function () {
            state.mediaIndex > 0 && (state.mediaIndex--, renderMedia(media))
        }), next && next.addEventListener("click", function () {
            state.mediaIndex < media.length - 1 && (state.mediaIndex++, renderMedia(media))
        }), wrap.querySelectorAll("[data-qv-thumb]").forEach(function (t) {
            t.addEventListener("click", function () {
                state.mediaIndex = parseInt(t.getAttribute("data-qv-thumb"), 10), renderMedia(media)
            })
        }), state._media = media, paintIcons()
    }

    function syncMediaToVariant() {
        var v = currentVariant();
        if (!(!v || v.featured_image == null || !state._media)) {
            for (var fid = v.featured_image.id, i = 0; i < state._media.length; i++)
                if (state._media[i].id === fid) {
                    state.mediaIndex = i, renderMedia(state._media);
                    break
                }
        }
    }

    function renderBody() {
        var p = state.product,
            v = currentVariant(),
            onSale = v && v.compare_at_price > v.price,
            pickerOpts = (p.options || []).map(function (opt, idx) {
                if (p.options.length === 1 && opt.name === "Title" && (opt.values || []).length === 1 && opt.values[0] === "Default Title") return null;
                var color = isColor(opt.name);
                return {
                    name: opt.name,
                    oi: idx,
                    isColor: color,
                    selected: color ? state.chosen[idx] : null,
                    values: opt.values.map(function (val) {
                        return {
                            value: val,
                            selected: String(state.chosen[idx]) === String(val),
                            available: valueAvailable(idx, val),
                            hex: color ? swatchColor(val) : null
                        }
                    })
                }
            }).filter(Boolean),
            pickers = pickerOpts.length ? window.UntamedSheets.renderVariantPicker([{
                pi: 0,
                options: pickerOpts
            }], {
                bare: !0
            }) : "",
            QV = window.UntamedSheets && window.UntamedSheets.qv || {},
            bodyHtml = (QV.showVendor && p.vendor ? '<div class="qv-eyebrow">' + esc(p.vendor) + "</div>" : "") + (QV.showType !== !1 && p.type ? '<div class="qv-eyebrow">' + esc(p.type) + "</div>" : "") + '<h2 class="qv-title">' + esc(p.title) + '</h2><div class="qv-price" data-qv-price></div>' + (pickers ? '<div class="qv-pickers">' + pickers + "</div>" : "") + '<div class="qv-foot"><div class="qv-atc-row"><div class="qv-qty"><button type="button" data-qv-qty="-1" aria-label="Decrease">' + ic("ph-minus") + '</button><span class="v" data-qv-qtyval>1</span><button type="button" data-qv-qty="1" aria-label="Increase">' + ic("ph-plus") + '</button></div><button class="ui-sheet__btn ui-sheet__btn--primary qv-atc" data-qv-atc>' + esc(QV.atc || "Add to cart") + '</button></div><a class="ui-sheet__btn ui-sheet__btn--secondary ui-sheet__btn--block qv-view-full" href="' + esc(p.url) + '">' + esc(QV.viewFull || "View full details") + " " + ic("ph-arrow-right") + '</a><div class="qv-error" data-qv-error hidden></div></div>';
        dom.body.querySelector("[data-qv-body]").innerHTML = bodyHtml, paintPrice(), bindBody(), paintIcons()
    }

    function paintPrice() {
        var v = currentVariant(),
            el = dom.body.querySelector("[data-qv-price]");
        if (el) {
            if (!v) {
                el.innerHTML = '<span class="now">\u2014</span>';
                return
            }
            var onSale = v.compare_at_price > v.price;
            el.innerHTML = '<span class="now">' + money(v.price) + "</span>" + (onSale ? '<span class="was">' + money(v.compare_at_price) + '</span><span class="save">Save ' + money(v.compare_at_price - v.price) + "</span>" : "");
            var atc = dom.body.querySelector("[data-qv-atc]");
            atc && (v.available ? atc.classList.contains("is-added") || (atc.textContent = "Add to cart", atc.disabled = !1) : (atc.textContent = "Sold out", atc.disabled = !0))
        }
    }

    function bindBody() {
        dom.body.querySelectorAll("[data-vp-val]").forEach(function (btn) {
            btn.addEventListener("click", function () {
                if (btn.getAttribute("aria-disabled") !== "true") {
                    var idx = parseInt(btn.getAttribute("data-vp-oi"), 10);
                    state.chosen[idx] = btn.getAttribute("data-vp-val"), emit("quick_view_variant_changed", {
                        product_handle: state.product.handle
                    }), renderBody(), syncMediaToVariant()
                }
            })
        }), dom.body.querySelectorAll("[data-qv-qty]").forEach(function (btn) {
            btn.addEventListener("click", function () {
                var d = parseInt(btn.getAttribute("data-qv-qty"), 10);
                state.qty = Math.max(1, state.qty + d);
                var v = dom.body.querySelector("[data-qv-qtyval]");
                v && (v.textContent = state.qty)
            })
        });
        var viewFull = dom.body.querySelector(".qv-view-full");
        viewFull && viewFull.addEventListener("click", function () {
            close();
        });
        var atc = dom.body.querySelector("[data-qv-atc]");
        atc && atc.addEventListener("click", addToCart)
    }

    function addToCart() {
        var v = currentVariant(),
            atc = dom.body.querySelector("[data-qv-atc]"),
            err = dom.body.querySelector("[data-qv-error]");
        if (err && (err.hidden = !0), !v) {
            err && (err.hidden = !1, err.textContent = "Please choose an option.");
            return
        }
        if (!window.CartAPI || !window.CartAPI.addItem) {
            err && (err.hidden = !1, err.textContent = "Cart is unavailable. Please try again.");
            return
        }
        atc.disabled = !0, atc.textContent = "Adding\u2026", window.CartAPI.addItem(v.id, state.qty).then(function () {
            emit("quick_view_added_to_cart", {
                product_handle: state.product.handle,
                variant_id: v.id,
                quantity: state.qty,
                price: v.price
            }), atc.disabled = !1, atc.textContent = "Add to cart", paintPrice(), close()
        }).catch(function () {
            atc.disabled = !1, atc.textContent = "Add to cart", err && (err.hidden = !1, err.textContent = "Could not add to cart. Please try again.")
        })
    }
    document.addEventListener("click", function (e) {
        var t = e.target.closest("[data-quick-view]");
        if (t) {
            var handle = t.getAttribute("data-product-handle");
            if (!handle) return;
            e.preventDefault(), e.stopPropagation(), open(handle, "quick_view_button");
            return
        }
        var card = e.target.closest("[data-quick-view-card]");
        if (card && !e.target.closest("[data-wishlist-btn], .product-card__color-swatches, .product-card__color-swatch, .product-card__actions, button, select, input, [data-no-quick-view]")) {
            var h = card.getAttribute("data-product-handle");
            h && (e.preventDefault(), open(h, "card_tap"))
        }
    }), document.addEventListener("keydown", function (e) {
        if (!(e.key !== "Enter" && e.key !== " ")) {
            var t = e.target.closest && e.target.closest("[data-quick-view]");
            t && (e.preventDefault(), open(t.getAttribute("data-product-handle"), "quick_view_button"))
        }
    });

    function intentPrefetch(e) {
        var el = e.target.closest && e.target.closest("[data-quick-view-card],[data-quick-view]");
        el && prefetch(el.getAttribute("data-product-handle"))
    }
    document.addEventListener("pointerover", intentPrefetch, {
        passive: !0
    }), document.addEventListener("focusin", intentPrefetch), document.addEventListener("touchstart", intentPrefetch, {
        passive: !0
    }), window.QuickView = {
        open: open,
        close: close
    }
})();
//# sourceMappingURL=/cdn/shop/t/129/assets/quick-view.js.map?v=61864325595976312611782758095